export default class StaticArticle {
  constructor(section) {
    this.initializedClass = 'article-initialized';
    this.el = section.el;
    this.$el = $(this.el);
    this._validate();
  }

  update() {
    this._validate();
  }

  onSectionUnload() {
    $(window).off('resize.article-view');
  }

  _validate() {
    if (window.innerWidth <= 1080) {
      this.positionSidebar('below');
    } else {
      this.positionSidebar();
    }

    this.setupFeaturedImage();
    this.setupFullWidthImages();

    $(window).on('resize.article-view', () => {
      this.setupFullWidthImages();
      if (window.innerWidth <= 1080) {
        this.positionSidebar('below');
      } else {
        this.positionSidebar();
        this.setupFeaturedImage();
      }
    });
  }

  setupFeaturedImage(setup) {
    const $posts = this.$el.find('.blog-post');

    $posts.each((index, post) => {
      const image = $(post).find('img.highlight').first();
      if (image.length) {
        $(post).find('.blog-post-inner').css({ paddingTop: image.height() - 60 });
      }
    });
  }

  setupFullWidthImages() {
    const postContent = this.$el.find('.post-content');
    const postContentWidth = postContent.outerWidth(true);
    const postContentMargin = postContent.css('marginLeft');

    const result = [];
    $('img.full-width', this.$el).each((index, image) => {
      image = $(image);

      result.push(image.css({
        width: postContentWidth,
        left: `-${postContentMargin}`,
      }));
    });

    return result;
  }

  positionSidebar(position) {
    const sidebar = this.$el.find('.blog-sidebar');

    if (position === 'below') {
      sidebar.insertAfter('.blog-post-wrapper');
    } else {
      sidebar.insertBefore('.blog-post-wrapper');
    }
  }
}
